import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'OCCUPANCY_PLANNER';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (institutionId, from, splitAt, groupBy, showChildLeaveAsAvailable) => ({
        institutionId,
        from,
        splitAt,
        groupBy,
        showChildLeaveAsAvailable,
    }),
    response => ({response}),
);

export const {
    action: resetAndFetch,
    success: resetAndFetchSuccess,
    failed: resetAndFetchFailed,
} = createAction(
    `${domain}/RESET_AND_FETCH`,
    (institutionId, splitAt, groupBy, showChildLeaveAsAvailable) => ({
        institutionId,
        splitAt,
        groupBy,
        showChildLeaveAsAvailable,
    }),
    response => ({response}),
);
